export const STATUS = {
  ZERO_STATE: 'ZERO_STATE',
  LOADING: 'LOADING',
  NO_RESULTS: 'NO_RESULTS',
  RESULTS: 'RESULTS',
};

export const FILTERS = [
  {
    title: 'Bot Elements',
    key: 'targets',
    options: [
      { value: 'all', title: 'All' },
      { value: 'user_responses', title: 'User Messages' },
      { value: 'bot_responses', title: 'Bot Responses' },
      { value: 'nodes', title: 'Steps' },
      { value: 'sub_stories', title: 'Skill' },
      { value: 'stories', title: 'Skill Set' },
      { value: 'generic_responses', title: 'Generic Responses' },
    ],
  },
  {
    title: 'Active/Inactive',
    key: 'state',
    options: [
      { value: 'all', title: 'All' },
      { value: 'active', title: 'Active' },
      { value: 'inactive', title: 'Inactive' },
    ],
  },
  {
    title: 'Language',
    key: 'languages',
    options: [
      { value: 'all', title: 'All' },
      { value: 'en', title: 'English' },
      { value: 'hi', title: 'Hindi' },
    ],
  },
  {
    title: 'Step Type',
    key: 'node_type',
    options: [
      { value: 'all', title: 'All' },
      { value: 0, title: 'Regular Steps' },
      { value: 1, title: 'FAQs' },
      { value: 2, title: 'Skill Steps' },
    ],
  },
];

export const DEFAULT_FILTERS = {
  targets: [
    { value: 'all', title: 'All' },
    { value: 'user_responses', title: 'User Messages' },
    { value: 'bot_responses', title: 'Bot Responses' },
    { value: 'nodes', title: 'Steps' },
    { value: 'sub_stories', title: 'Skill' },
    { value: 'stories', title: 'Skill Sets' },
    { value: 'generic_responses', title: 'Generic Responses' },
  ],
  state: [
    { value: 'all', title: 'All' },
    { value: 'active', title: 'Active' },
    { value: 'inactive', title: 'Inactive' },
  ],
  languages: [
    { value: 'all', title: 'All' },
    { value: 'en', title: 'English' },
    { value: 'hi', title: 'Hindi' },
  ],
  node_type: [
    { value: 'all', title: 'All' },
    { value: 0, title: 'Regular Steps' },
    { value: 1, title: 'FAQs' },
    { value: 2, title: 'Skill Steps' },
  ],
};

export const SAMPLE_RESPONSE = {
  success: true,
  body: {
    bot_responses: [
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483b0e0985f01f6b5dcc90',
        match_string:
          'Please help me with the month of Travel.<m>{chatform}{464}',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 33,
            end: 39,
          },
        ],
        node_name: 'CALL_RECEIVED',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483af40985f01f6b5dbf36',
        match_string:
          'Hi %name! Travelling cashless is travelling smart \ud83d\udc4d <m>{"data":{"items":[{"actionable_text":"Know More!","location_required":false,"is_default":1,"uri":"LINK","type":"APP_ACTION","payload":{"url":"http://tracking.affiliatehub.co.in/aff_c?offer_id=6553&aff_id=2239","link":"http://tracking.affiliatehub.co.in/aff_c?offer_id=6553&aff_id=2239","gogo_message":""},"emoji":""}]},"text":"Haptik has partnered with Kotak Mahindra Bank to bring you an all-digital 811 savings account.\\n\\nNo more cash or card required, spend hassle free on your travels.","type":"BUTTON"}',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 10,
            end: 16,
          },
        ],
        node_name: 'CASHLESS_TRAVEL',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483b030985f01f6b5dc7dc',
        match_string:
          'Here you go \ud83d\ude0a<m>Tap below \ud83d\udc47 to find the Extra baggage charges for your preferred airline:<m>{"text":"Here you go. Extra baggage charges for your preferred airline:","type":"CAROUSEL","data":{"items":[{"title":"AIR INDIA","description":"","sub_title":"\ud83d\udcbc Extra baggage details","tool_name":"","meta":"","actionables":[{"actionable_text":"Learn more","location_required":false,"uri":"LINK","is_default":0,"type":"APP_ACTION","payload":{"url":"http://www.airindia.in/excess-baggage.htm","link":"","message":"\ufe0f","gogo_message":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/891ec54953cd11abee78cc24f4ddf7b463c68684c64878a55b174c6557ac0087.jpeg?w=1106&h=6232.png","type":"LANDSCAPE"}},{"title":"SPICE JET","description":"","sub_title":"\ud83d\udcbc Extra baggage details","tool_name":"","meta":"","actionables":[{"actionable_text":"Learn more","location_required":false,"uri":"LINK","is_default":0,"type":"APP_ACTION","payload":{"url":"http://www.spicejet.com/AirTravelBaggageFaq.aspx","link":"","message":"\ufe0f","gogo_message":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/891ec54953cd11abee78cc24f4ddf7b4a2d27ddaa9c57a08db9ef11b0cc27430.jpeg?w=1101&h=618.png","type":"LANDSCAPE"}},{"title":"JET AIRWAYS","description":"","sub_title":"\ud83d\udcbc Extra baggage details","tool_name":"","meta":"","actionables":[{"actionable_text":"Learn more","location_required":false,"uri":"LINK","is_default":0,"type":"APP_ACTION","payload":{"url":"https://www.jetairways.com/EN/AU/TravelInformation/Baggage/baggage-allowances.aspx","link":"","message":"\ufe0f","gogo_message":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/891ec54953cd11abee78cc24f4ddf7b487ab3618833227aeeaa6d735b13150cb.jpeg?w=1105&h=624.png","type":"LANDSCAPE"}},{"title":"INDIGO","description":"","sub_title":"\ud83d\udcbc Extra baggage details","tool_name":"","meta":"","actionables":[{"actionable_text":"Learn more","location_required":false,"uri":"LINK","is_default":0,"type":"APP_ACTION","payload":{"url":"https://www.goindigo.in/travel-information/en/pre-paid-baggage.html","link":"","message":"\ufe0f","gogo_message":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/891ec54953cd11abee78cc24f4ddf7b459d69c9b6fe6edc4f5f369385c320869.jpeg?w=1105&h=623.png","type":"LANDSCAPE"}},{"title":"GO AIR","description":"","sub_title":"\ud83d\udcbc Extra baggage details","tool_name":"","meta":"","actionables":[{"actionable_text":"Learn more","location_required":false,"uri":"LINK","is_default":0,"type":"APP_ACTION","payload":{"url":"https://www.goair.in/services/pre-book-excess-baggage/","link":"","message":"\ufe0f","gogo_message":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/891ec54953cd11abee78cc24f4ddf7b412a716faae7533ab2c68b6f367177453.jpeg?w=1103&h=618.png","type":"LANDSCAPE"}},{"title":"VISTARA","description":"","sub_title":"\ud83d\udcbc Extra baggage details","tool_name":"","meta":"","actionables":[{"actionable_text":"Learn more","location_required":false,"uri":"LINK","is_default":0,"type":"APP_ACTION","payload":{"url":"https://www.airvistara.com/trip/excess_baggage","link":"","message":"\ufe0f","gogo_message":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/891ec54953cd11abee78cc24f4ddf7b47eeb84c66d056019dcaa3618492617cb.jpeg?w=1104&h=622.png","type":"LANDSCAPE"}}]}}<m>For other Airlines / International Flights, we request you to contact your specific airline to get further information.',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 980,
            end: 986,
          },
          {
            start: 1507,
            end: 1513,
          },
        ],
        node_name: 'CHARGES_EXTRA_BAGGAGE',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483af70985f01f6b5dc1cf',
        match_string:
          'Awesome! Travelling is always a great idea!\ud83d\udeeb \ud83c\udfd6\ufe0f<m>To get started, I want to understand a little bit more about your requirements\ud83d\ude00<m>{chatform}{409}',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 9,
            end: 15,
          },
        ],
        node_name: 'INTERESTED_IN_TRAVEL_PACKAGE',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483b0e0985f01f6b5dcc87',
        match_string:
          'Travelling is always a great idea.<m>We have partnered with *SOTC* so you can plan a memorable vacation at best prices.<m>Above all, we have some exotic destinations\u26f1. Have a look.\ud83d\ude0a<m>{"type":"CAROUSEL","data":{"width":"MEDIUM","image_aspect_ratio":2.1,"items":[{"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621318773a9a29ac753f646ca696a6ad2f3.jpeg?w=2362&h=1654","type":"LANDSCAPE"},"title":"BALI","sub_title":"Starting only Rs.10k per day","actionables":[{"actionable_text":"View Details","location_required":false,"is_default":1,"uri":"CAROUSEL_DEFAULT","type":"APP_ACTION","payload":{"actionable_text":"Know more","description":"Below itinerary is a sample and can be customized as per the requirement.\\n\\nDAY 1\\n\\nArrive into Denpasar(Bali).\\n\\nDAY 2\\n\\nProceed for a full day excursion to the Kintamani Volcano.\\n\\nDay 3\\n\\n Travel to Tanah Lot Temple .\\n\\nDAY 4\\n\\nFamous Tanjung Benoa Beach.\\n\\nDAY 5\\n\\nFree for you to explore the city on your own.\\n\\nDAY 6\\n\\nTake back many happy memories of your holiday.","title":"BALI","sub_title":"","link":"","actionables":[{"actionable_text":"I\'m interested","location_required":false,"uri":"","is_default":1,"type":"TEXT_ONLY","payload":{"link":"","gogo_message":"I\'m interested{product_id:international, product_name: Bali, api_name:sotc}"},"emoji":""}],"images":["http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621f7e8b6637eb53b07e119567463982483.jpeg?w=1280&h=800","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac6218553bab66b100cba693beb7a20f21aed.jpeg?w=465&h=310","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac6214446a65f25aae30ab7348a4e09a8340a.jpeg?w=1152&h=864"]},"emoji":""},{"actionable_text":"I\'m interested","type":"TEXT_ONLY","uri":"","location_required":false,"is_default":1,"payload":{"message":"I\'m interested{product_id:international, product_name: Bali, api_name:sotc}","gogo_message":""}}]},{"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac6213afeea63adf9b7420e344a0f119152f2.jpeg?w=1600&h=900","type":"LANDSCAPE"},"title":"BHUTAN","sub_title":"Starting only Rs.6k per day","actionables":[{"actionable_text":"View Details","location_required":false,"is_default":1,"uri":"CAROUSEL_DEFAULT","type":"APP_ACTION","payload":{"actionable_text":"Know more","description":"Below itinerary is a sample and can be customized as per the requirement.\\n\\nDAY 1\\n\\nArrival at PARO airport.\\n\\nDAY 2\\n\\nTHIMPHU Sightseeing.\\n\\nDay 3\\n\\nTHIMPHU \u2013 PUNAKHA / WANGDI.\\n\\nDAY 4\\n\\nDRIVE PUNAKHA / WANGDI \u2013 PARO.\\n\\nDAY 5\\n\\nPARO SIGHTSEEING OR OPTIONAL TOUR (Not included in cost).\\n\\nDAY 6\\n\\nPARO \u2013 HAA VALLEY EXCURSION \u2013 PARO.\\n\\nDAY 7\\n\\nTRANSFER TO PARO AIRPORT.","title":"BHUTAN","sub_title":"","link":"","actionables":[{"actionable_text":"I\'m interested","location_required":false,"uri":"","is_default":1,"type":"TEXT_ONLY","payload":{"link":"","gogo_message":"I\'m interested{product_id:international, product_name: Bhutan, api_name:sotc}"},"emoji":""}],"images":["http://haptikappimg.haptikapi.com/content/313ea5646bb5d9c5c66a91ab681e900cc48e15c90562e5c9955a8f76ee17d83a.jpeg?w=1000&h=667","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac62122d46fde35fbd6a953688497a6523883.jpeg?w=1920&h=1080","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac62132690ea6ee7bac0ebe1a105fef5c3b9f.jpeg?w=1920&h=1080"]},"emoji":""},{"actionable_text":"I\'m interested","type":"TEXT_ONLY","uri":"","location_required":false,"is_default":1,"payload":{"message":"I\'m interested{product_id:international, product_name: Bhutan, api_name:sotc}","gogo_message":""}}]},{"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621d60566bd757edbb50754d250ad3be005.jpeg?w=1920&h=1200","type":"LANDSCAPE"},"title":"MAURITIUS","sub_title":"Starting only Rs.9k per day","actionables":[{"actionable_text":"View Details","location_required":false,"is_default":1,"uri":"CAROUSEL_DEFAULT","type":"APP_ACTION","payload":{"actionable_text":"Know more","description":"Below itinerary is a sample and can be customized as per the requirement.\\n\\nDAY 1\\n\\nArrive Mauritius\\n\\nDAY 2\\n\\nFull day tour of North Island. Proceed to Port Louis for a visit.  View the Champ de Mars race course.\\n\\nDay 3\\n\\nProceed to Belle Mare .\\n\\nDAY 4\\n\\nDepart on a full day tour of south Island. \\n\\nDAY 5\\n\\nDay is free at leisure.\\n\\nDAY 6\\n\\nThe day is at leisure. You can opt to visit Casela Bird Park.\\n\\nDAY 7\\n\\nProceed to the airport to board your flight to an onward destination on back home.","title":"MAURITIUS","sub_title":"","link":"","actionables":[{"actionable_text":"I\'m interested","location_required":false,"uri":"","is_default":1,"type":"TEXT_ONLY","payload":{"link":"","gogo_message":"I\'m interested{product_id:international, product_name: Mauritius, api_name:sotc}"},"emoji":""}],"images":["http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621d5835ba17d325ff0266d218b1938788e.jpeg?w=4223&h=2811","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621b3afe8835a9079759bac4784bca12dfc.jpeg?w=1499&h=811","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac6213eba51b6fa9f069dab2fbdae048d8c9d.jpeg?w=1600&h=900"]},"emoji":""},{"actionable_text":"I\'m interested","type":"TEXT_ONLY","uri":"","location_required":false,"is_default":1,"payload":{"message":"I\'m interested{product_id:international, product_name: Mauritius, api_name:sotc}","gogo_message":""}}]},{"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/313ea5646bb5d9c5c66a91ab681e900c93523d9fd1c004a4a3ddfc400e662a9c.jpeg?w=1500&h=370","type":"LANDSCAPE"},"title":"EGYPT","sub_title":"Starting only Rs.11k per day","actionables":[{"actionable_text":"View Details","location_required":false,"is_default":1,"uri":"CAROUSEL_DEFAULT","type":"APP_ACTION","payload":{"actionable_text":"Know more","description":"Below itinerary is a sample and can be customized as per the requirement.\\n\\nDAY 1\\n\\nArrive at Cairo to Begin your \u2018Wonders of Egypt\u2019 Tour.\\n\\nDAY 2\\n\\nDay Trip to Alexandria.\\n\\nDay 3\\n\\nCity Tour of Cairo.\\n\\nDAY 4\\n\\nAswan, Boarding the Nile River Cruise.\\n\\nDAY 5\\n\\nAbu Simbel, the High Dam & the Temple of Kom Ombo.\\n\\nDAY 6\\n\\nEdfu, Luxor via Esna Lock, Temple of Luxor.\\n\\nDAY 7\\n\\nValley of the Kings, Temple of Hatshepsut, Karnak Temple.\\n\\nDAY 8\\n\\nReturn Home with Wonderful Memories.","title":"EGYPT","sub_title":"","link":"","actionables":[{"actionable_text":"I\'m interested","location_required":false,"uri":"","is_default":1,"type":"TEXT_ONLY","payload":{"link":"","gogo_message":"I\'m interested{product_id:international, product_name: Egypt, api_name:sotc}"},"emoji":""}],"images":["http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621af2ac432de4e9405bc1b24b7850b7d15.jpeg?w=1920&h=1200","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac62130a9e24095a407e516913758eef50419.jpeg?w=1920&h=1080","http://haptikappimg.haptikapi.com/content/d42a9ad09e9778b177d409f5716ac621eeec546c2efd846826aa2153b89e5a42.jpeg?w=1280&h=400"]},"emoji":""},{"actionable_text":"I\'m interested","type":"TEXT_ONLY","uri":"","location_required":false,"is_default":1,"payload":{"message":"I\'m interested{product_id:international, product_name: Egypt, api_name:sotc}","gogo_message":""}}]}]}}',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
          {
            start: 879,
            end: 885,
          },
        ],
        node_name: 'INTRO_SOTC',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483aeb0985f01f6b5db868',
        match_string: 'Travel',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
        ],
        node_name: 'SALE_PUSH',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483b0e0985f01f6b5dcc88',
        match_string:
          "That's great! Travelling is always a great idea\ud83d\ude04<m>This festive season, we have partnered with *SOTC* to offer you highly curated select deals so you can just venture into one of these exotic locations without a worry.<m>{chatform}{74}",
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 14,
            end: 20,
          },
        ],
        node_name: 'TRAVEL_DETAILS',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483b0e0985f01f6b5dcc89',
        match_string:
          "That's great! Travelling is always a great idea\ud83d\ude04<m>This festive season, we have partnered with *SOTC* to offer you highly curated select deals so you can just venture into one of these exotic locations without a worry.<m>{chatform}{74}",
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 14,
            end: 20,
          },
        ],
        node_name: 'TRAVEL_DETAILS',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483ae50985f01f6b5db572',
        match_string:
          'Happy to help you! \u263a\ufe0f Pick from one of the options below.<m>{"text":"Travelling by Flights","type":"CAROUSEL","data":{"items":[{"description":"What can I help you with?","title":"Flights Travel","sub_title":"","tool_name":"","meta":"","actionables":[{"actionable_text":"Flight Tickets","location_required":false,"uri":"","is_default":0,"type":"TEXT_ONLY","payload":{"gogo_message":"","message":"I want to book flight tickets","link":""},"emoji":""},{"actionable_text":"Web-check In","location_required":false,"uri":"","is_default":0,"type":"TEXT_ONLY","payload":{"gogo_message":"","message":"I want to skip the queue! Please web-checkin for me.","link":""},"emoji":""}],"thumbnail":{"image":"http://haptikappimg.haptikapi.com/content/8b8cd297bc8bc690780e03a320c38ff558713f7dd99577fce82da0446e937bf9.jpeg?w=1330&h=742","type":"LANDSCAPE"}}]}}',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 69,
            end: 75,
          },
          {
            start: 187,
            end: 193,
          },
        ],
        node_name: 'TRAVEL_FLIGHTS_PARENT',
      },
      {
        domain_name: 'travel',
        key: 'responses',
        document_id: '5b483afe0985f01f6b5dc557',
        match_string:
          'The convenience fee *per passenger* is as follows:<m>\ud83c\uddee\ud83c\uddf3 Domestic Travel:\nOne-way: *\u20b9250*\nReturn: *\u20b9400*<m>\ud83c\udf0e International Travel:\nOne-way: *\u20b9600*\nReturn: *\u20b9600*',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 65,
            end: 71,
          },
          {
            start: 122,
            end: 128,
          },
        ],
        node_name: 'TRAVEL_HOW_MUCH_CONVENIENCE_FEES',
      },
    ],
    user_responses: [
      {
        domain_name: 'travel',
        key: 'sentence',
        document_id: '5a27f4210985f05b3ba932de',
        match_string: 'Hey, I want some help with Train Travel .',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 33,
            end: 39,
          },
        ],
        node_name: 'TRAINS_DISCONTINUED_IN_TRAVEL',
      },
      {
        domain_name: 'travel',
        key: 'sentence',
        document_id: '5a27f4210985f05b3ba932df',
        match_string: 'Hi! I need some help planning my Train Travel .',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 39,
            end: 45,
          },
        ],
        node_name: 'TRAINS_DISCONTINUED_IN_TRAVEL',
      },
      {
        domain_name: 'travel',
        key: 'sentence',
        document_id: '5aec082ec636425a08eb28dd',
        match_string: 'Travel Packages Holiday',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
        ],
        node_name: 'TRAVEL_OUTLIERS',
      },
      {
        domain_name: 'travel',
        key: 'sentence',
        document_id: '5aec0c35c636425a08eb28e3',
        match_string: 'Travel Packages Holiday Destination',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
        ],
        node_name: 'TRAVEL_PACKAGE_INACTIVE',
      },
    ],
    generic_responses: [
      {
        domain_name: 'travel',
        key: '',
        document_id: '5c0fc1ae7eddbb002100wa52',
        match_string: '',
        match_pattern: 'travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
          {
            start: 13,
            end: 19,
          },
        ],
      },
    ],
    nodes: [
      {
        domain_name: 'travel',
        key: 'node_name',
        document_id: '5c0fc1ae7eddbb002100ea52',
        match_string: 'travel::GEN::travel_started',
        match_pattern: 'travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
          {
            start: 13,
            end: 19,
          },
        ],
        substory_name: 'Tap Travel Packages',
      },
    ],
    stories: [
      {
        domain_name: 'travel',
        key: 'story_name',
        document_id: '59cb9e20297f130810a4f519',
        match_string: 'Travel packages',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
        ],
      },
    ],
    sub_stories: [
      {
        domain_name: 'travel',
        key: 'sub_story_name',
        document_id: '59ef066c0985f0031a5fc312',
        match_string: 'Tap Travel Packages',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 4,
            end: 10,
          },
        ],
        story_name: 'Travel',
      },
      {
        domain_name: 'travel',
        key: 'story_name',
        document_id: '59cb9e20297f130810a4f519',
        match_string: 'Travel packages',
        match_pattern: 'Travel',
        match_indexes: [
          {
            start: 0,
            end: 6,
          },
        ],
        story_name: 'Travel packages',
      },
    ],
  },
  error: '',
  meta: {},
};
